import { useTranslation } from "react-i18next";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import {Consts} from "../pages/consts";

const ImageFileUpload = ({ symptomNumber, onFilesChanged }) => {
  const { t: t } = useTranslation();
  const [thumbnails, setThumbnails] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [fileNames, setFileNames] = useState([]);
  const [files, setFiles] = useState([]);

  const handleFileChange = (event) => {
    const newFiles = Array.from(event.target.files);
    const newThumbnails = newFiles?.map((file) => URL.createObjectURL(file));
    const newFileNames = newFiles?.map((file) => file.name);
    setThumbnails((prevThumbnails) => [...prevThumbnails, ...newThumbnails]);
    setFileNames((prevFileNames) => [...prevFileNames, ...newFileNames]);
    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    onFilesChanged(symptomNumber, [...files, ...newFiles]);
  };

  const handleThumbnailClick = (thumbnail) => {
    setSelectedImage(thumbnail);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  const handleRemoveThumbnail = (index) => {
    const newThumbnails = thumbnails?.filter((_, i) => i !== index);
    const newFileNames = fileNames?.filter((_, i) => i !== index);
    const newFiles = files?.filter((_, i) => i !== index); // Entfernen der Datei
    setThumbnails(newThumbnails);
    setFileNames(newFileNames);
    setFiles(newFiles);
    onFilesChanged(symptomNumber, newFiles);
  };

  return (
    <>
      <input
        id="image-file-upload"
        type={Consts.FILE}
        accept="image/*"
        multiple
        onChange={handleFileChange}
        style={{ display: Consts.NONE }}
      />
      <label
        htmlFor="image-file-upload"
        className="w3-btn w3-round-xlarge w3-theme-d5 responsive-button"
      >
        {t("add_related_images")} ({t("if_applicable")})
      </label>
      <div className="w3-row w3-margin-top">
        {thumbnails?.map((thumbnail, index) => (
          <div key={index} className="w3-col s3 w3-border w3-margin-left">
            <FontAwesomeIcon
              icon={faXmark}
              onClick={() => handleRemoveThumbnail(index)}
              className="w3-right label-link"
            />
            <img
              src={thumbnail}
              alt={`${t("thumbnail")} ${index}`}
              className="w3-image w3-hover-opacity thumbnail"
              title={fileNames[index]}
              onClick={() => handleThumbnailClick(thumbnail)}
            />
          </div>
        ))}
      </div>
      {selectedImage && (
        <div className="image-fullscreen-container" onClick={handleCloseModal}>
          <img
            src={selectedImage}
            alt={t("selected")}
            className="image-fullscreen"
          />
          <div className="image-fullscreen-close">
            <label>{t("click_to_close")}</label>
          </div>
        </div>
      )}
      {thumbnails.length > 0 && (
        <div className="w3-row w3-margin-left w3-white w3-center">
          <label>{t("click_on_thumbnail_to_enlarge")}</label>
        </div>
      )}
    </>
  );
};

export default ImageFileUpload;
